export const validateEmail = (email: string) => {
  const regex =
    /^[a-zA-Z0-9]{1,}@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
  return regex.test(email);
};
